
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([active]){
  display:block;
  width:100%;
  position:relative;
}

  :host([active]) .combo-box--list{
    display:flex;
    flex-direction:column;
    padding:0;
    position:absolute;
    background-color:var(--color-neutral-white);
    z-index:3;
    border:solid 1px var(--color-neutral-dark);
    border-top:none;
    width:100%;
    max-height:var(--spacing-64);
    overflow-y:auto;
  }

  :host([active]) ul{
    list-style:none;
    padding:0;
    margin:0;
  }

  :host([active]) li{
    color:var(--color-neutral-dark);
    font-size:var(--body-01-font-size);
    display:flex;
    padding:var(--spacing-04) var(--spacing-06);
    height:100%;
    width:100%;
    text-decoration:none;
    font-weight:var(--sic-font--font-weight--normal);
    position:relative;
    z-index:2;
    margin:0;
  }

  :host([active]) li[aria-selected='true']{
      background-color:var(--color-neutral-lightest);
    }

  :host([active]) li:hover{
      background-color:var(--color-primary-lightest);
      font-weight:var(--fw-bold);
    }

  :host([active]) li:focus{
      outline:solid 3px var(--color-primary-default);
      outline-offset:-2px;
    }

.combo-box--label{
  display:block;
  margin-bottom:var(--spacing-04);
  font-size:var(--body-01-min-font-size);
}

.combo-box--button{
  border:1px solid var(--color-neutral-dark);
  position:sticky;
  cursor:pointer;
  display:flex;
  width:100%;
  align-items:center;
  justify-content:space-between;
  color:var(--color-neutral-dark);
  background-color:var(--color-neutral-white);
  margin:0;
  padding:var(--spacing-04);
  font-size:var(--body-01-font-size);
  z-index:1;
}

.combo-box--button.active{
    background-color:var(--color-neutral-lightest);
  }

.combo-box--button:focus-visible{
    outline:2px solid var(--color-system-info-darkest);
  }

.combo-box--button[aria-disabled='true']{
    cursor:not-allowed;
    pointer-events:none;
    background-color:var(--color-neutral-lightest);
  }

.combo-box--list{
  display:none;
}

.hidden{
  display:none;
}

.combo-box--overlay:after{
  content:'';
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:0;
}
`;